import React, { useState } from "react";
import styles from "./Reports.module.scss";
import { useSelector } from "react-redux";
import printJS from "print-js";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import DatePicker from "@mui/lab/DatePicker";
import Stack from "@mui/material/Stack";
import { Alert, AlertTitle, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import {
  IPartnerOrderRequestModel,
  IPartnerReportRequestModel,
} from "../../interfaces/order";
import apis from "../../api/apis";
import { APIResponseType } from "../../config/enumApiResponseTypes";
import SnackBar, { SnackBarModel } from "../snackBar/SnackBar";
import { notifyServerError } from "../../config/toastNotification";
import LoadingComponent from "../loadingComponent/LoadingComponent";
import { API_INTEGRATION_ID } from "../../config";
import moment from "moment";
import { DesktopDatePicker } from "@mui/lab";
import { Print } from "@material-ui/icons";

const Reports = () => {
  // let currentDate = moment(moment.now()).format("DD-MM-YYYY");

  const [fromDate, setFromDate] = useState<Date | any>(
    moment(moment.now()).format()
  );
  const [toDate, setToDate] = useState<Date | any>(
    moment(moment.now()).format()
  );
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);

  //snack bar model
  const [snackBarmodel, setSnackBarModel] = useState<SnackBarModel>({
    openSnackBar: false,
    msg: "",
    autoHideDuration: 6000,
  });

  const { user } = useSelector((state: any) => state.authentication);

  const handleFromDateFilter = (newValue: Date | null) => {
    setFromDate(newValue);
  };

  const handleToDateFilter = (newValue: Date | null) => {
    setToDate(newValue);
  };

  const b64toBlob = (base64: string, type = "application/pdf") =>
    fetch(`data:${type};base64,${base64}`).then((res) => res.blob());

  const handleReports = async () => {
    //  window.alert("from" + fromDate + "to" + toDate);
    // alert(fromDate);
    // return;
    if (fromDate === null || toDate === null) {
      seterror(true);
      return;
    } else {
      seterror(false);
      const requestModel: IPartnerReportRequestModel = {
        PartnerOrderId: 1,
        OrderId: "",
        POSStatusKey: 0,
        OrderDate: undefined,
        OrderTypeKey: 0,
        DenyOrCancelReasonCode: "",
        DenyOrCancelReasonKey: 0,
        CurrentPOSStatusCode: "",
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user.CompanyKey,
          LocationKey: user.LocationKey,
          UserKey: user.UserKey,
          EnvironmentName: user.EnvironmentName,
          IsUrbanPiper: false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
        fromDate: fromDate,
        toDate: toDate,
      };

      setloading(true);
      const response = await apis.Orders.getXReport(requestModel);

      if (response.ResponseType === APIResponseType.Success) {
        if (response.ResponseData.PartnerOrder.SalesReportSource !== null) {
          //Build a URL from the file
          const fileURL = URL.createObjectURL(
            await b64toBlob(
              response.ResponseData.PartnerOrder.SalesReportSource
            )
          );
          console.log(fileURL);

          //Open the URL on new Window
          //window.open(fileURL);
          setloading(false);
          printJS(fileURL);
        } else {
          //show error msg
          setloading(false);
          setSnackBarModel({
            openSnackBar: true,
            msg: "Error: Report Source Not Found !",
            autoHideDuration: 6000,
          });
        }
      } else {
        setloading(false);
        notifyServerError();
      }
    }
    // const requestModel: IPartnerReportRequestModel = {
    //   PartnerOrderId: 1,
    //   OrderId: "",
    //   POSStatusKey: 0,
    //   OrderDate: undefined,
    //   OrderTypeKey: 0,
    //   DenyOrCancelReasonCode: "",
    //   DenyOrCancelReasonKey: 0,
    //   CurrentPOSStatusCode: "",
    //   OrderReference: "",
    //   RequestId: "",
    //   IntegrationId: "",
    //   ApiKey: "",
    //   UID: {
    //     CompanyKey: user.CompanyKey,
    //     LocationKey: user.LocationKey,
    //     UserKey: user.UserKey,
    //     EnvironmentName: user.EnvironmentName,
    //     IsUrbanPiper: false,
    //   },
    //   RequestingUser: 0,
    //   RequestingId: "",
    //   Schema: "",
    //   ValidationMessages: [],
    //   IsApprovedStatus: 0,
    //   IsActive: 0,
    //   fromDate: fromDate,
    //   toDate: toDate,
    // };

    // setloading(true);
    // const response = await apis.Orders.getXReport(requestModel);

    // if (response.ResponseType === APIResponseType.Success) {
    //   if (response.ResponseData.PartnerOrder.BillReportSource !== null) {
    //     //Build a URL from the file
    //     const fileURL = URL.createObjectURL(
    //       await b64toBlob(response.ResponseData.PartnerOrder.BillReportSource)
    //     );

    //     //Open the URL on new Window
    //     //window.open(fileURL);
    //     setloading(false);
    //     printJS(fileURL);
    //   } else {
    //     //show error msg
    //     setloading(false);
    //     setSnackBarModel({
    //       openSnackBar: true,
    //       msg: "Error: Report Source Not Found !",
    //       autoHideDuration: 6000,
    //     });
    //   }
    // } else {
    //   setloading(false);
    //   notifyServerError();
    // }
  };

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className={styles.report_container}>
      {error && <Alert severity="error">Please select a date range</Alert>}
      <div className={styles.date_container}>
        <div className={styles.from_date}>
          <label htmlFor="">From :</label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={3}>
              <DesktopDatePicker
                disableFuture
                // label="Filter from:"
                inputFormat="dd/MM/yyyy"
                value={fromDate}
                onChange={handleFromDateFilter}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
        </div>

        <div className={styles.to_date}>
          <label htmlFor="">To :</label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={3}>
              <DesktopDatePicker
                disableFuture
                // label="Filter to:"
                inputFormat="dd/MM/yyyy"
                value={toDate}
                onChange={handleToDateFilter}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
        </div>
      </div>
      <div className={styles.btn_container}>
        {/* <button onClick={handleReports}>Generate</button> */}
        <Button
          variant="outlined"
          startIcon={<Print />}
          onClick={handleReports}
        >
          Generate
        </Button>
      </div>
    </div>
  );
};

export default Reports;
